import React, { useEffect, useState } from 'react';
import Modal from '../../../layout/modal/Modal';
import styles from './ClientDetailsModal.module.scss';
import clsx from 'clsx';
import { Grid, IconButton, Button } from '@material-ui/core';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AddIcon from '@mui/icons-material/Add';
import HistoryIcon from '@mui/icons-material/History';
import EditIcon from '@mui/icons-material/Edit';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import VideocamIcon from '@mui/icons-material/Videocam';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import DocumentationHistoryTable from './DocumentationHistoryTable/DocumentationHistoryTable';
import { connect } from 'react-redux';
import {
	getPurchasers,
	getAgreementstList,
	getPurchaserByLeadId,
} from '../../../../redux/purchasers/actions';
import { closeModal, openModal } from '../../../../redux/modals/action';
import FormModal from './FormModal/FormModal';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { getAgreementDataById } from '../../../../redux/agreement/actions';
import getCoolingPeriodTime from '../../../../api/Purchasers/getCoolingPeriodTime.api';
import dayjs from 'dayjs';
import getContractStatus from '../../../../api/Purchasers/getContractStatus.api';
import { getAppointment } from '../../../../redux/deals/action';
import MeetingStatus from '../../../meetingStatus/MeetingStatus';
import { useHistory } from 'react-router';
import StripeProcessing from '../../stripeIdentification/StripeProcessing';
import StripeSection from '../../stripeIdentification/StripeSection';
import { reformatPhoneString2 } from '../../../../utils/validatePhoneNumber';
import _ from 'lodash';

const PurchasersModals = ({
	clientDetails,
	handleCloseClientDetails,
	client,
	handleOpenAddDocument,
	agreementsList,
	getPurchaserByLeadId,
	openModal,
	handleOpenFormFields,
	handleOpenPurchaserForm,
	getAgreementstList,
	getAgreementDataById,
	handleExtend,
	getAppointment,
	appointmentDetails,
	currentUserDetails,
	closeModal,
	getPurchasers,
	openVerificationModal,
}) => {
	const [agreement, setAgreement] = useState();
	const [daysDifference, setDaysDifference] = useState();
	const [togglIdentification, setTogglIdentification] = useState(true);
	const [tabs, setTabs] = useState([]);
	const [activeTab, setActiveTab] = useState(0);
	const [contractStatus, setContractStatus] = useState();

	var history = useHistory();

	useEffect(() => {
		getAgreementstList();
	}, []);
	useEffect(() => {
		getAgreementDataById(client?.leadId);
	}, [clientDetails]);
	useEffect(() => {
		setTogglIdentification(true);
	}, [activeTab]);
	useEffect(() => {
		let arr = [];
		let clientInfo = agreement?.clientInfo;

		if (clientInfo?.corporation) {
			// 1. Corporation
			arr.push(clientInfo?.corporation);
		} else if (clientInfo?.individual) {
			// 2. Individual
			let individualObjs = clientInfo?.individual;
			_.forEach(individualObjs, function (el) {
				el['leadId'] = client?.leadId;
				arr.push(el);
			});
		}
		setTabs(arr);
	}, [agreement]);

	useEffect(() => {
		//getPurchasers();
	}, [client]);

	useEffect(() => {
		getAppointment(client?.leadId);
		client &&
			getContractStatus({ leadId: client.leadId }, (returned) => {
				setContractStatus(returned);
			});
	}, [client?.leadId]);

	useEffect(() => {
		setAgreement(
			agreementsList?.find((item) => item.leadsKey === client?.leadId)
		);

		getPurchaserByLeadId(client?.leadToSalesAgent, client?.leadId);
	}, [agreementsList]);

	useEffect(() => {
		var coolingPeriodEnd = agreement?.documentInformation?.coolingPeriodEnd;

		var difference =
			coolingPeriodEnd && dayjs(coolingPeriodEnd)?.diff(dayjs(), 'day');

		setDaysDifference(difference);
	}, [agreement]);

	const handleDepositSchedule = () => {
		openModal('depositSchedule');
	};

	const handleScheduleMeeting = () => {
		openModal('scheduleMeeting');
	};

	const handleVideoCall = () => {
		var detailsForCall = {
			thisEmail: appointmentDetails?.users[0]?.email,
			thisName: appointmentDetails?.appointmentName,
			thisAppointmentCode: appointmentDetails?.appointmentID,
			thisAppointmentTime: appointmentDetails?.timeOfAppointment,
			thisUserType: currentUserDetails?.userType,
			thisPhone: appointmentDetails?.users[0]?.phoneNumber,
			thisUID: currentUserDetails?.uid,
			shortCode: appointmentDetails?.shortCode,
		};

		history.push({
			pathname: '/videocall',
			state: {
				detail: detailsForCall,
			},
		});

		closeModal('clientDetails');
	};
	const onClickTab = (index) => {
		setActiveTab(index);
	};

	return (
		<div className={styles.clientDetailsModal} key={client?.leadId}>
			<Modal
				show={clientDetails}
				close={handleCloseClientDetails}
				wrapperWidth={'95%'}
				wrapperMax={1180}
				tabs={tabs}
				activeTab={activeTab}
				onClickTab={onClickTab}
				onClickAddForm={() =>
					handleOpenPurchaserForm(client?.leadId, false, null)
				}
			>
				<div className={styles.sections_wrapper}>
					<div className={styles.section}>
						<div className={styles.header_lg}>
							<h2>
								{tabs[activeTab]?.firstName ||
									client?.clientFName}
								&nbsp;
								{tabs[activeTab]?.lastName ||
									client?.clientLName}
							</h2>
							<IconButton
								className={styles.edit_icon}
								aria-label='edit purchaser'
								onClick={() =>
									handleOpenPurchaserForm(
										client?.leadId,
										true,
										tabs[activeTab]
									)
								}
							>
								<EditIcon />
							</IconButton>
							{agreement?.clientInfo?.individual && (
								<>
									<StripeProcessing
										selected={tabs[activeTab]}
										openVerificationModal={() =>
											openVerificationModal(
												tabs[activeTab],
												client?.leadId
											)
										}
										hide={togglIdentification}
										handleTogleStripe={() =>
											setTogglIdentification(false)
										}
										isLead={false}
									/>
								</>
							)}
						</div>
						<Grid container spacing={2} className={styles.section}>
							<Grid item xs={12} sm={6}>
								<div className={styles.header_font}>
									<span>
										{tabs[activeTab]?.occupation}
										{tabs[activeTab]?.directorFirstName}
										&nbsp;
										{tabs[activeTab]?.directorLastName}
									</span>
								</div>
								<div className={styles.header_font}>
									<span>
										{tabs[activeTab]?.phoneNumber ||
											client?.clientPhoneNumber}
										&nbsp;|&nbsp;
									</span>
									<span>
										{tabs[activeTab]?.email ||
											client?.clientEmail}
									</span>
								</div>
							</Grid>
							<Grid item xs={12} sm={6}>
								<div className={styles.header_meeting_info}>
									{client?.sentEmail === true &&
										appointmentDetails && (
											<MeetingStatus
												leadId={client?.leadId}
												appointment={appointmentDetails}
											/>
										)}
								</div>
								<div className={styles.header_meeting_info}>
									{client?.sentEmail === true ? (
										<div
											className={
												styles.header_meeting_btn
											}
											onClick={() => handleVideoCall()}
										>
											<VideocamIcon /> Join Meeting
										</div>
									) : (
										<div
											className={
												styles.header_meeting_btn
											}
											onClick={() =>
												handleScheduleMeeting()
											}
										>
											<CalendarTodayIcon /> Schedule
											Meeting
										</div>
									)}
								</div>
							</Grid>
						</Grid>
					</div>
					{agreement?.clientInfo?.individual && (
						<>
							<StripeSection
								hide={togglIdentification}
								selected={tabs[activeTab]}
								openVerificationModal={() =>
									openVerificationModal(
										tabs[activeTab],
										client?.leadId
									)
								}
							/>
							<center>
								{!togglIdentification && (
									<IconButton
										className={styles.edit_icon}
										aria-label='close identification'
										onClick={() =>
											setTogglIdentification(true)
										}
									>
										<ExpandLessIcon />
									</IconButton>
								)}
							</center>
						</>
					)}
					<div className={styles.section}>
						<div className={styles.section_title}>
							<InfoOutlined />
							<span className={styles.section_title_text}>
								Deal Specifications
							</span>
						</div>

						<hr />
						<Grid
							className={styles.section}
							container
							xs={12}
							alignItems='center'
						>
							<Grid item xs={3}>
								<div className={styles.item}>
									<div className={styles.small}>Source</div>
									<div className={styles.title}>
										{client?.reference
											? client?.reference
											: '---'}
									</div>
								</div>
							</Grid>
							<Grid item xs={3}>
								{agreement?.cobroker ? (
									<div className={styles.editItem}>
										<div className={styles.item}>
											<div className={styles.small}>
												Co-Broker
											</div>
											<div className={styles.title}>
												{agreement?.cobroker?.agentName}
											</div>
										</div>

										<div
											className={styles.editBtn}
											onClick={() =>
												handleOpenFormFields(
													'cobroker',
													client?.leadId,
													true
												)
											}
										>
											<EditIcon />
										</div>
									</div>
								) : (
									<div className={styles.item_button}>
										<div
											className={styles.button}
											onClick={() =>
												handleOpenFormFields(
													'cobroker',
													client?.leadId
												)
											}
										>
											<AddIcon /> Co-Broker
										</div>
									</div>
								)}
							</Grid>
							<Grid item xs={3}>
								{agreement?.lawyer ? (
									<div className={styles.editItem}>
										<div className={styles.item}>
											<div className={styles.small}>
												Lawyer
											</div>
											<div className={styles.title}>
												{agreement?.lawyer?.companyName}
											</div>
										</div>

										<div
											className={styles.editBtn}
											onClick={() =>
												handleOpenFormFields(
													'lawyer',
													client?.leadId,
													true
												)
											}
										>
											<EditIcon />
										</div>
									</div>
								) : (
									<div className={styles.item_button}>
										<div
											className={styles.button}
											onClick={() =>
												handleOpenFormFields(
													'lawyer',
													client?.leadId
												)
											}
										>
											<AddIcon />
											Lawyer
										</div>
									</div>
								)}
							</Grid>

							<Grid item xs={3}>
								{agreement?.mortgage ? (
									<div className={styles.editItem}>
										<div className={styles.item}>
											<div className={styles.small}>
												Mortgage
											</div>
											<div className={styles.title}>
												${' '}
												{numberWithCommas(
													Number(
														agreement?.mortgage
															?.mortgageValue
													).toFixed(2)
												)}
											</div>
										</div>

										<div
											className={styles.editBtn}
											onClick={() =>
												handleOpenFormFields(
													'mortgage',
													client?.leadId,
													true
												)
											}
										>
											<EditIcon />
										</div>
									</div>
								) : (
									<div className={styles.item_button}>
										<div
											className={styles.button}
											onClick={() =>
												handleOpenFormFields(
													'mortgage',
													client?.leadId
												)
											}
										>
											<AddIcon /> Mortgage
										</div>
									</div>
								)}
							</Grid>
						</Grid>

						<hr />

						<Grid
							className={styles.section}
							container
							alignItems='center'
						>
							<Grid item xs={6}>
								<div className={styles.item}>
									<div className={styles.title}>
										{/* @TODO: If you want cooling period, uncomment this */}
										{/* {agreement?.documentInformation
									?.coolingPeriodEnd ? (
									<>
										{`${daysDifference} days left - ${dayjs(
											agreement?.documentInformation
												.coolingPeriodEnd
										).format('MMM DD. YYYY')}`}{' '}
										<span
											className={styles.extendCooling}
											onClick={() =>
												handleExtend(
													agreement
														?.documentInformation
														.coolingPeriodEnd,
													client.leadId
												)
											}
										>
											Extend
										</span>
									</>
								) : (
									'---'
								)} */}
										<div className={styles.small}>
											Firm Deal
										</div>
										{agreement?.documentInformation
											?.coolingPeriodStart
											? dayjs(
													agreement
														?.documentInformation
														?.coolingPeriodStart
											  ).format('MMM DD YYYY')
											: '---'}
									</div>
								</div>
							</Grid>
							<Grid item xs={6}>
								<div
									className={`${styles.item_button} ${styles.deposit_schedule}`}
								>
									<Button
										className={
											contractStatus?.name ===
											'Incomplete'
												? null
												: styles.button
										}
										onClick={() => handleDepositSchedule()}
										disabled={
											contractStatus?.name ===
											'Incomplete'
										}
									>
										Deposit Schedule
									</Button>
								</div>
							</Grid>
						</Grid>
					</div>
					<div
						className={styles.section}
						style={{ paddingBottom: 0 }}
					>
						<div className={styles.section_title}>
							<HistoryIcon />
							<span className={styles.section_title_text}>
								Documentation History
							</span>
						</div>
						<hr />
						<DocumentationHistoryTable
							handleOpenAddDocument={handleOpenAddDocument}
							client={client}
						/>
					</div>
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	agreementsList: state.purchasers.agreements,
	modal: state.modals,
	appointmentDetails: state.leads.appointmentDetailByLeadId,
	currentUserDetails: state.signIn,
	// agreementById: state.agreement?.agreementById,
});

export default connect(mapStateToProps, {
	getPurchaserByLeadId,
	openModal,
	getAgreementstList,
	getAgreementDataById,
	getAppointment,
	closeModal,
	getPurchasers,
})(PurchasersModals);
